import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Nav, NavItem, NavLink, TabContent, TabPane, Table } from 'reactstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Papa from "papaparse";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import classnames from "classnames";
import moment from 'moment';
import dayjs from 'dayjs'; // Import dayjs for date handling

const CustomCheckerDetailPage = () => {

    const classId = window.location.pathname.split('/').pop(); // Extract class ID from URL

    const [className, setClassName] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date()); // Selected date on the calendar

    const [activeSubTab, setActiveSubTab] = useState("students");
    const [eventRecords, setEventRecords] = useState([]); // For /events/bySchoolDate
    const [monthlySummary, setMonthlySummary] = useState([]); // For /events/monthlySummary
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');


    // 🔹 Fetch all student custom attendance events for the school on the selected date
    const fetchSchoolEventsByDate = async (date) => {
        setLoadingEvents(true);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const formattedDate = dayjs(date).format('YYYY-MM-DD');

        try {
            const res = await API.get(`/customAttendance/events/bySchoolDate`, {
                headers,
                params: { date: formattedDate },
            });

            if (res.data.response_code === 1000) {
                setEventRecords(res.data.data || []);
            } else {
                toast.error(res.data.message || "Failed to load event records");
            }
        } catch (error) {
            console.error("❌ Error fetching event records:", error);
            toast.error("Error fetching event records");
        } finally {
            setLoadingEvents(false);
        }
    };
    const fetchMonthlySummary = async (date) => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const month = dayjs(date).format("YYYY-MM");

        try {
            const res = await API.get(`/customAttendance/events/monthlySummary`, {
                headers,
                params: { month },
            });
            console.log(res)
            if (res.data.response_code === 1000) {
                setMonthlySummary(res.data.data || []);
            } else {
                toast.error(res.data.message || "Failed to load monthly summary");
            }
        } catch (error) {
            console.error("❌ Error fetching monthly summary:", error);
            toast.error("Error fetching monthly summary");
        }
    };

    useEffect(() => {
        fetchSchoolEventsByDate(selectedDate);
        fetchMonthlySummary(selectedDate);
    }, [classId, selectedDate]);

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;

        const formattedDate = dayjs(date).format("YYYY-MM-DD");

        // find record for this date
        const record = monthlySummary.find(item => item.date === formattedDate);
        if (!record) return null;

        // hide if there are no check-ins or check-outs
        if ((record.check_in_count || 0) === 0 && (record.check_out_count || 0) === 0) {
            return null;
        }

        // choose a color based on activity
        const background = record.check_in_count > 0 ? "#E8F5E9" : null;
        const color = "#2E7D32";

        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background,
                    color,
                    borderRadius: "8px",
                    padding: "4px",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                {record.check_in_count > 0 ? record.unique_students : ""}
            </div>
        );
    };

    const groupedRecords = eventRecords?.reduce((acc, group) => {
        // Each group is a class (e.g. { class_name, students: [...] })
        const className = group.class_name || "";
        acc[className] = group.students || [];
        return acc;
    }, {});


    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className='row gx-0'>
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2">
                                    <h4 className="mb-0 flex-grow-1">Event {className}</h4>

                                </div>

                                <div className="card-body">
                                    <div className="calendar-modern">
                                        <Calendar
                                            value={selectedDate}
                                            onChange={(date) => {
                                                setSelectedDate(date);

                                            }}
                                            tileContent={tileContent}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <TabContent activeTab={activeSubTab} className="border-start border-end border-bottom p-3">
                        <TabPane tabId="students">
                            <div className="card-body">

                                {loadingEvents ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-danger mb-3" role="status" style={{ width: "3rem", height: "3rem" }} />
                                        <h6 className="fw-semibold text-muted">Loading...</h6>
                                        <small className="text-gray">Please wait while data is being fetched.</small>
                                    </div>
                                ) : groupedRecords && Object.keys(groupedRecords).length > 0 ? (

                                    <>
                                        <div style={{
                                            width: "100%",
                                            overflowX: "auto",
                                            WebkitOverflowScrolling: "touch",
                                            marginTop: "1rem",
                                        }}>

                                            {Object.entries(groupedRecords).map(([className, students]) => (
                                                <div key={className} className="mb-4">
                                                    <div className="d-flex justify-content-end mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search student name or ID..."
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                            style={{
                                                                maxWidth: "300px",
                                                                borderRadius: "8px",
                                                                boxShadow: "0 0 3px rgba(0,0,0,0.1)",
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="table-responsive">
                                                        <Table bordered hover style={{ borderRadius: "8px", overflow: "hidden" }}>
                                                            <thead className="">
                                                                <tr>
                                                                    <th style={{ width: "5%" }}>#</th>
                                                                    <th>Student</th>
                                                                    <th>Status</th>
                                                                    <th>Gate</th>
                                                                    <th>Timestamp</th>
                                                                    <th>Photo</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {students
                                                                    .filter(s => {
                                                                        if (!searchTerm) return true;
                                                                        const term = searchTerm.toLowerCase();
                                                                        return (
                                                                            s.student_name?.toLowerCase().includes(term) ||
                                                                            s.student_uuid?.toLowerCase().includes(term)
                                                                        );
                                                                    })
                                                                    .map((s, i) => (

                                                                        <tr key={s.student_uuid || i}>
                                                                            <td>{i + 1}</td>
                                                                            <td>
                                                                                <div className="d-flex align-items-start gap-2">
                                                                                    <div>
                                                                                        <div className="fw-semibold">{s.student_name}</div>
                                                                                        <small className="text-muted">{s.student_uuid}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <span
                                                                                    className={`badge ${s.status === 1
                                                                                        ? "bg-success"
                                                                                        : s.status === 2
                                                                                            ? "bg-info"
                                                                                            : "bg-secondary"
                                                                                        }`}
                                                                                    style={{
                                                                                        fontSize: "0.8rem",
                                                                                        padding: "6px 10px",
                                                                                        fontWeight: "500",
                                                                                    }}
                                                                                >
                                                                                    {s.status === 1
                                                                                        ? "Check-in"
                                                                                        : s.status === 2
                                                                                            ? "Check-out"
                                                                                            : "—"}
                                                                                </span>
                                                                            </td>
                                                                            <td>{s.gate || "-"}</td>
                                                                            <td>
                                                                                <span
                                                                                    style={{
                                                                                        whiteSpace: "nowrap",
                                                                                        fontSize: "0.85rem",
                                                                                        color: "#555",
                                                                                    }}
                                                                                >
                                                                                    {s.timestamp || "-"}
                                                                                </span>
                                                                            </td>
                                                                            <td style={{ position: "relative", height: "160px", verticalAlign: "middle" }}>
                                                                                {s.image ? (
                                                                                    <div
                                                                                        style={{
                                                                                            position: "relative",
                                                                                            display: "inline-block",
                                                                                            overflow: "visible",
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={s.image}
                                                                                            alt="event"
                                                                                            style={{
                                                                                                width: 120,
                                                                                                height: 120,
                                                                                                borderRadius: "10px",
                                                                                                objectFit: "cover",
                                                                                                cursor: "zoom-in",
                                                                                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                                                                                transformOrigin: "center center",
                                                                                                zIndex: 1,
                                                                                                position: "relative",
                                                                                            }}
                                                                                            onMouseEnter={(e) => {
                                                                                                const img = e.currentTarget;
                                                                                                img.style.transform = "scale(2.6)";
                                                                                                img.style.zIndex = "9999";
                                                                                                img.style.position = "absolute";
                                                                                                img.style.top = "50%";
                                                                                                img.style.left = "50%";
                                                                                                img.style.transformOrigin = "center center";
                                                                                                img.style.translate = "-50% -50%";
                                                                                                img.style.boxShadow = "0 10px 35px rgba(0,0,0,0.4)";
                                                                                                img.style.border = "2px solid rgba(255,255,255,0.8)";
                                                                                                img.style.background = "white";
                                                                                            }}
                                                                                            onMouseLeave={(e) => {
                                                                                                const img = e.currentTarget;
                                                                                                img.style.transform = "scale(1)";
                                                                                                img.style.zIndex = "1";
                                                                                                img.style.position = "relative";
                                                                                                img.style.top = "0";
                                                                                                img.style.left = "0";
                                                                                                img.style.boxShadow = "none";
                                                                                                img.style.border = "none";
                                                                                                img.style.background = "none";
                                                                                                img.style.translate = "0 0";
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <span className="text-muted">No image</span>
                                                                                )}
                                                                            </td>

                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                    </>

                                ) : (
                                    <div className="text-center py-5">
                                        <h6 className="text-muted mb-2">No student for this date</h6>
                                        <small className="text-gray">Try selecting a different date on the calendar.</small>
                                    </div>
                                )}

                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </Fragment>
    );
};

export default CustomCheckerDetailPage;
